import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import AuthorizationsListResponsiveTableRow from './AuthorizationListResponsiveTableRow';

const AuthorizationListResponsiveTableBody = ({
  userGroups,
  authorizations,
  dispatch,
  onRefineAuthorization,
  onUnrefineAuthorization,
  changedPermissions
}) => {
  return (
    <TableBody>
      {authorizations?.map((authorization, index) => {
        return (
          <AuthorizationsListResponsiveTableRow
            key={authorization.webAuthorizationId}
            userGroups={userGroups}
            authorization={authorization}
            index={index}
            dispatch={dispatch}
            authorizationChangedPermissions={changedPermissions[authorization.webAuthorizationId] || {}}
            onRefineAuthorization={onRefineAuthorization}
            onUnrefineAuthorization={onUnrefineAuthorization}
          />
        );
      })}
    </TableBody>
  );
};

AuthorizationListResponsiveTableBody.propTypes = {
  changedPermissions: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  authorizations: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  onRefineAuthorization: PropTypes.func.isRequired,
  onUnrefineAuthorization: PropTypes.func.isRequired
};

export default AuthorizationListResponsiveTableBody;
